export const CURRENT_REQUESTED_DOCUMENT_TABLE_ROW_TEST_IDS = {
  downloadButton: 'documents-table-download-button',
} as const;
